// test729
(729 && 0);
